import { render } from "./SchedulesEdit.vue?vue&type=template&id=4edca728&scoped=true"
import script from "./SchedulesEdit.vue?vue&type=script&lang=js"
export * from "./SchedulesEdit.vue?vue&type=script&lang=js"

import "./SchedulesEdit.vue?vue&type=style&index=0&id=4edca728&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edca728"]])

export default __exports__